import { debounce } from 'throttle-debounce';
import scrollInView, { ScrollInViewType } from '../service/scrollInView';
import { useState } from 'react';

const useSectionScrollWatcher = (sectionId: string) => {
  const [isSectionInView, setIsSectionInView] = useState(false);

  const checkSectionVisibility = debounce(50, () => {
    const section: HTMLElement | null = document.getElementById(sectionId);

    const isInView: boolean = section ? scrollInView.isInView(section, ScrollInViewType.ANY) : false;

    return setIsSectionInView(isInView);
  });

  return {
    isSectionInView,
    checkSectionVisibility,
  };
};

export default useSectionScrollWatcher;
